import { Box, styled, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import Layout from '../components/Layout';
import MySessionMyKss from '../components/mySessionMyKSS';
import MySessionsNextSession from '../components/mySessionsNextSession';
import MySessionsTopButton from '../components/mySessionsTopButton';
import MySessionsWeekProgress from '../components/mySessionsWeekProgress';
import ProgressBehaviors from '../components/progressBehaviors';
import {
    userAtom,
    kssDataAtom,
    userForAdminPanelAtom,
    userKssTrackerDataForAdminPanelAtom,
} from '../recoil/atoms/userAtom';
import { colors } from '../styles/globalStyles';
import { dateFormatDiff, timeFormatDiff } from '../functions/nextSessionFormat';
import { getMyWeekProgress } from '../api/stats';
import { weekProgressDataAtom } from '../recoil/atoms/mySessionPageAtoms';
import textData from '../data/data.json';
import { selectedLanguageAtom } from '../recoil/atoms/languageAtom';

const TypographyMySessions = styled(Typography)({
    paddingInline: 10,

    fontWeight: 700,
    fontSize: 24,
    lineHeight: '100%',

    '& span': {
        color: colors.main,
    },
});

const WeekProgressAndNextSession = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    height: 217,

    '& > *': {
        width: '50%',
    },
});

const MySessions = () => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { mySessions } = textData[selectedLanguage];
    const setWeekData = useSetRecoilState(weekProgressDataAtom);

    const [isUpdateAvaliable, setIsUpdateAvaliable] = useState(false);
    const kssData = useRecoilValue(kssDataAtom);

    const user = useRecoilValue(userAtom);
    const userForAdminPanel = useRecoilValue(userForAdminPanelAtom);
    const userKssForAdminPanel = useRecoilValue(userKssTrackerDataForAdminPanelAtom);

    const userIdForAdminPanel = localStorage.getItem('user-id-for-admin-panel');

    const finalUserData = userIdForAdminPanel ? userForAdminPanel : user;
    const finalKssData = userIdForAdminPanel ? userKssForAdminPanel : kssData;

    const timeHours = useMemo(
        () => timeFormatDiff(finalUserData.session?.next_date, finalUserData.session?.meeting_date),
        [finalUserData.session],
    );
    const timeDate = useMemo(
        () => dateFormatDiff(finalUserData.session?.next_date, finalUserData.session?.meeting_date, selectedLanguage),
        [finalUserData.session],
    );

    localStorage.setItem('session-team', finalUserData?.session?.id);

    useEffect(() => {
        getMyWeekProgress(userIdForAdminPanel || null)
            .then((res) => {
                setWeekData(res.data);
            })
            .catch((err) => {
                console.error('Ошибка получения данных о недельном прогрессе', err);
            });
    }, [setWeekData, userIdForAdminPanel]);

    useEffect(() => {
        const updated_at = finalKssData.find((kssItem) => kssItem?.updated_at)?.updated_at;

        if (+updated_at?.slice(8, 10) === new Date().getDate()) {
            setIsUpdateAvaliable(true);
        }
    }, [finalKssData, userIdForAdminPanel]);

    if (!finalUserData.session) {
        return (
            <Layout link={'/'}>
                <Box
                    sx={{
                        height: '40svh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <TypographyMySessions dangerouslySetInnerHTML={{ __html: mySessions.titles[0] }} />
                </Box>
            </Layout>
        );
    }

    return (
        <Layout link={'/'}>
            <TypographyMySessions dangerouslySetInnerHTML={{ __html: mySessions.titles[1] }} />

            {!userIdForAdminPanel && <MySessionsTopButton />}
            {finalKssData.length === 0 && <MySessionsTopButton KSS={true} />}

            {finalKssData.length !== 0 && isUpdateAvaliable && <MySessionsTopButton KSS={true} update={true} />}

            <WeekProgressAndNextSession>
                <MySessionsWeekProgress />
                <MySessionsNextSession link={finalUserData?.session?.meeting_link} hours={timeHours} date={timeDate} />
            </WeekProgressAndNextSession>
            <MySessionMyKss />
            <ProgressBehaviors />
        </Layout>
    );
};

export default MySessions;
